/**
 * Presales AI recommendation allowlist (organization subdomain and name).
 * Keep in sync with infrastructure/lambda/shared/src/ai-recommendation-access.ts
 */
export const AI_RECOMMENDATION_PRESALES_SUBDOMAINS = [
  'sales-ops',
] as const;

/** @deprecated Use AI_RECOMMENDATION_PRESALES_SUBDOMAINS */
export const AI_RECOMMENDATION_PRESALES_ORG_SLUGS = AI_RECOMMENDATION_PRESALES_SUBDOMAINS;

export function normalizeSubdomain(subdomain: string | undefined | null): string | null {
  if (!subdomain?.trim()) return null;
  return subdomain.trim().toLowerCase();
}

export function isPresalesAiSubdomain(subdomain: string | undefined | null): boolean {
  const normalized = normalizeSubdomain(subdomain);
  if (!normalized) return false;
  return (AI_RECOMMENDATION_PRESALES_SUBDOMAINS as readonly string[]).includes(normalized);
}

/** True when subdomain or organization name matches the presales allowlist. */
export function isPresalesAiOrganization(
  organizationName: string | undefined | null,
  subdomain?: string | undefined | null,
): boolean {
  return isPresalesAiSubdomain(subdomain) || isPresalesAiSubdomain(organizationName);
}
